import { Web3Button } from "@web3modal/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClaimLOL, OnlyOwner, VestingConfig } from "../components";
import { useWallet } from "../context/web3.context";

export default function Vesting(): JSX.Element {
  const { isConnected, lolTokenBalance } = useWallet();
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  const tabs = [
    {
      name: "Claim LOL",
      href: "#claim",
      component: <ClaimLOL />,
    },
    {
      name: "Configure",
      href: "#configure",
      component: <OnlyOwner children={<VestingConfig />} />,
    },
  ];

  return (
    <>
      <div className="mb-6 text-center">
        {isConnected && lolTokenBalance ? (
          <div className="mb-6 text-center">
            <span
              className="px-3 py-1 text-lg leading-0 rounded-lg bg-blue-800 outline-dashed outline-2 outline-offset-2 outline-blue-700 cursor-pointer"
              onClick={() => navigate("/market/profile")}
            >
              LOL Balance: {lolTokenBalance}
            </span>
          </div>
        ) : (
          <div className="mb-6 text-center">
            <span className="flex items-center justify-center w-fit mx-auto px-3 py-1 text-lg leading-0 rounded-lg bg-blue-800 outline-dashed outline-2 outline-offset-2 outline-blue-700 cursor-wait">
              <div>LOL Balance: </div>
              <div role="status">
                <svg
                  aria-hidden="true"
                  className="w-4 h-4 ml-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
            </span>
          </div>
        )}
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select tab
          </label>
          <select
            id="tabs"
            className="bg-gray-50 border-0 border-b border-blue-800 text-gray-900 text-sm rounded-t-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-blue-800 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            {tabs.map((_tab, index) => (
              <option
                key={index}
                onClick={() => setTab(index)}
                className={`${tab === index ? "text-blue-700" : ""}`}
              >
                {_tab.name}
              </option>
            ))}
          </select>
        </div>
        <ul
          className="hidden text-sm font-medium text-center text-gray-500 divide-x divide-gray-200 rounded-lg sm:flex dark:divide-blue-800 dark:text-gray-400"
          id="fullWidthTab"
          data-tabs-toggle="#fullWidthTabContent"
          role="tablist"
        >
          {tabs.map((_tab, index) => (
            <li key={index} className="flex-1">
              <button
                onClick={() => setTab(index)}
                type="button"
                role="tab"
                aria-controls="stats"
                aria-selected="true"
                className={`${
                  tab === index
                    ? "text-gray-900 dark:text-white"
                    : "text-gray-500 dark:text-gray-400"
                } w-full py-4 px-1 font-medium focus:outline-none`}
              >
                {_tab.name}
              </button>
            </li>
          ))}
        </ul>
        <div
          id="fullWidthTabContent"
          className="border-t border-gray-200 dark:border-blue-800"
        >
          <div
            className="flex items-center justify-center p-4 bg-white rounded-b-lg md:p-8 dark:bg-gray-800 min-w-[300px] min-h-[300px] sm:min-w-[500px]"
            id="stats"
            role="tabpanel"
            aria-labelledby="stats-tab"
          >
            {isConnected ? (
              tabs[tab].component
            ) : (
              <div className="flex flex-col items-center justify-center h-full gap-6">
                <h1 className="text-2xl font-medium text-gray-700 dark:text-white">
                  Please connect your wallet to continue
                </h1>
                <Web3Button icon="hide" avatar="hide" balance="show" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
